import { Route, Routes } from "react-router-dom";
import "./App.css";

import { ROUTES } from "constants/routes";

import { HomePage } from "pages/HomePage";

import { SignIn } from "pages/SignIn";
import { SignUp } from "pages/SignUp";
import { ForgotPassword } from "pages/ForgotPassword";
import { ResetPassword } from "pages/ResetPassword";
import { AuthCallback } from "pages/AuthCallback";
import { ExperimentPage } from "pages/ExperimentPage";
import { setupAxios } from "utils/AxiosUtils";

setupAxios();

const App = () => {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path={ROUTES.signIn} element={<SignIn />} />
      <Route path={ROUTES.signUp} element={<SignUp />} />
      <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />
      <Route path={ROUTES.resetPassword} element={<ResetPassword />} />
      <Route path={ROUTES.authCallback} element={<AuthCallback />} />
      <Route path={ROUTES.experiment} element={<ExperimentPage />} />
    </Routes>
  );
};

export default App;
